import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'subscriptions',
    component: Children,

    children: [
      {
        path: '',
        name: 'subscriptions',
        component: () => import('../pages/SubscriptionsPage.vue')
      }
    ]
  }
];

export default routes;
